import { useMemo } from "react";
import { RxCheck } from "react-icons/rx";

import { cn, P } from "@sorcery/ui";

export const CollectionTrackingMessage = ({
  itemsInCollection,
  itemsInDeckAndSideboard,
  className = "",
}: {
  itemsInCollection: number | undefined;
  itemsInDeckAndSideboard: number | undefined;
  className?: string;
}) => {
  const showCollectionStuff =
    typeof itemsInCollection !== "undefined" && typeof itemsInDeckAndSideboard !== "undefined";
  const hasEnoughInCollection = useMemo(
    () =>
      showCollectionStuff && itemsInCollection > 0 && itemsInCollection >= itemsInDeckAndSideboard,
    [itemsInCollection, itemsInDeckAndSideboard, showCollectionStuff],
  );

  return showCollectionStuff ? (
    <div
      className={cn(
        "my-2 text-left transition-colors",
        hasEnoughInCollection ? "text-[#1fe9ff]" : "text-red",
        className,
      )}
    >
      {itemsInCollection > 0 && itemsInCollection >= itemsInDeckAndSideboard && (
        <RxCheck className={"mr-1 inline"} size={15} />
      )}
      <P className="inline">
        {itemsInCollection}
        <span>{!hasEnoughInCollection && ` / ${itemsInDeckAndSideboard}`}</span>{" "}
        <span>in your Collection</span>
      </P>
    </div>
  ) : null;
};
